import { useEffect, useState } from "react";
import useApiUrlTranslation from "../components/useApiUrlTranslation";

const useGetMainCycleLangEventComposantByIdEventCycleLang = ({ idEventList }) => {

    const { i18n, apiUrlTranslation } = useApiUrlTranslation();

    const [mainCycleLangEventComposantByIdEventCycleLangList, setMainCycleLangEventComposantByIdEventCycleLangList] = useState(false);

    const getMainCycleLangEventComposantByIdEventCycleLang = async ({ idEventList }) => {

        await fetch(`${apiUrlTranslation}?action=getMainCycleLangEventComposantByIdEventCycleLang&id_event_list=${idEventList}&get_parents=0&get_children=0`)
            .then(res => res.json())
            .then(res => {
                setMainCycleLangEventComposantByIdEventCycleLangList(res.data);
            })
    }

    useEffect(() => {
        if (idEventList && idEventList.length > 0) {
            getMainCycleLangEventComposantByIdEventCycleLang({ idEventList });
        }
    }, [i18n.resolvedLanguage])

    return { mainCycleLangEventComposantByIdEventCycleLangList, getMainCycleLangEventComposantByIdEventCycleLang };

}

export default useGetMainCycleLangEventComposantByIdEventCycleLang;